import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from 'styled-components'
import { BrandContext } from '@ppay/client'

import './sass/index.scss'
import './i18n'

import { App } from './App'
import { theme } from './theme'

ReactDOM.render(
  <BrandContext.Provider value="0xpay">
    <ThemeProvider theme={theme}>
      <React.StrictMode>
        <Suspense fallback={null}>
          <App />
        </Suspense>
      </React.StrictMode>
    </ThemeProvider>
  </BrandContext.Provider>,
  document.getElementById('root')
)
